import React from "react";
import DeleteTournament from "../../DeleteTournament/DeleteTournament";
import QRCodeGenerator from "../Tournament/QRCodeGenerator";

const SettingsTab = ({ tournament }) => {
  if (!tournament) return null;

  return (
    <div className="space-y-6">
      <section id="settings-qr" className="scroll-mt-20">
        <QRCodeGenerator
          tournamentId={tournament.slug || tournament.id}
          tournamentName={tournament.name}
        />
      </section>

      <DeleteTournament tournament={tournament} />
    </div>
  );
};

export default SettingsTab;
